<script setup lang="ts">
import { useData } from '../../_composables/useData';
import ImageCarousel from '@components/util/ImageCarousel.vue';

interface IProps {
    forMobile?: boolean;
}
const { forMobile } = defineProps<IProps>();
const { hotelPackage, loadingClass } = useData();
const hotelModule = useHotelModule();
const isLoading = computed(() => hotelModule.isLoadingHotelInfo);
</script>
<template>
    <section class="slider-section" :class="loadingClass">
        <DelayHydration>
            <ImageCarousel
                v-if="!isLoading"
                :images="hotelPackage.photos"
                :button-size="{ desktop: 'big', mobile: 'small' }"
                :pagination="forMobile"
                :no-slider="forMobile"
                :no-border-radius="forMobile"
                pre-mount-swiper
                :preload-first-image="forMobile"
            />
        </DelayHydration>
    </section>
</template>
<style scoped lang="scss">
.slider-section {
    @include desktop-only {
        width: 100%;
        padding: 20px;
        height: 580px;
        background-color: white;
        @include shadow();
        border-radius: 20px;
    }
    @include mobile-only {
        height: 226px;
    }
}
</style>
